import React from "react";
import img from "../../../assets/images/industry/1.png";
import icon from "../../../assets/images/industry/icons/1.png";
import img2 from "../../../assets/images/industry/2.png";
import icon2 from "../../../assets/images/industry/icons/2.png";
import industryData from "./industryData";
import IndustryCard from "./IndustryCard";
function Industry() {
  return (
    <div className="py-4 py-lg-5 finalSectionBottom container">
      <div className="position-relative mb-2">
        <h2 className=" font_600 mb-0 HomeBannerText ourproductMainhead font_14 line_height1_7 text-black text-center pt-0">
          Industries We Serve
        </h2>
        <h3 className="ourProductPositionhead mb-0 font_600 w-100 text-center">
          Industries We Serve
        </h3>
      </div>
      <p className="font_14 font_400 line_height1_7 text_light1 text-center mb-2">
        Tailored solutions for diverse industry needs
      </p>
      <div className="row mt-4">
        <div className="container">
          <div className="row">
            {industryData.map((industry, index) => (
              <IndustryCard key={index} {...industry} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Industry;
